import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Icon } from '../icon';
import { AnimationFixed } from '../animation/Animation';
export var initialSidebarState = {
  position: 'left',
  children: null,
  visible: false
};
export var SidebarComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  pointer-events: auto;\n  ", "\n  overflow: scroll;\n"])), function (props) {
  return props.closeType === 'back' ? 'padding: 56px 0;' : "";
});
export var CloseButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: 0px;\n  margin: 0px;\n  padding: 0px;\n  background: none;\n  box-shadow: none;\n  outline: none;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 100;\n"])));
export var BackArrow = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: 0px;\n  margin: 0px;\n  padding: 0px;\n  background: none;\n  box-shadow: none;\n  outline: none;\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  z-index: 100;\n"])));
export var Sidebar = function Sidebar(_ref) {
  var position = _ref.position,
      children = _ref.children,
      visible = _ref.visible,
      handleClose = _ref.handleClose,
      closeType = _ref.closeType;
  var animation = position === 'left' ? 'fadeInSlideLeft' : 'fadeInSlideRight';

  var preventBodyScroll = function preventBodyScroll() {
    if (visible) {
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.height = 'auto';
      document.body.style.overflow = 'auto';
    }
  };

  useEffect(function () {
    preventBodyScroll(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return ReactDOM.createPortal(React.createElement(Transition, {
    in: visible,
    timeout: 300
  }, function (state) {
    return React.createElement(AnimationFixed, {
      name: animation,
      position: position,
      className: "animation-".concat(state),
      duration: ".5"
    }, React.createElement(SidebarComponent, {
      closeType: closeType
    }, closeType === 'close' && React.createElement(CloseButton, {
      type: "button",
      onClick: handleClose
    }, React.createElement(Icon, {
      name: "icon-light-close",
      color: "rgba(0, 0, 24, 0.84);",
      size: "24"
    })), (closeType === 'back' || closeType === 'backFilter') && React.createElement(BackArrow, {
      type: "button",
      onClick: handleClose
    }, React.createElement(Icon, {
      name: "icon-light-arrow-left",
      color: "rgba(0, 0, 24, 0.84);",
      size: "24"
    })), children));
  }), document.getElementById('sidebars'));
};